import React from "react";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
import HeaderOne from "../../components/HeaderOne";
import Breadcrumb from "../../components/Breadcrumb";
import SearchProductListPage from "../../components/product_list/SearchProductListPage";
import ShippingTwo from "../../components/ShippingTwo";
import FooterOne from "../../components/FooterOne";
import ColorInit from "../../helper/ColorInit";

const SearchProductList = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth />

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      <HeaderOne category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Shop"} />

      {/* SearchProductListPage */}
      <SearchProductListPage />

      {/* ShippingTwo */}
      <ShippingTwo />

      {/* FooterOne */}
      <FooterOne />
    </>
  );
};
export default SearchProductList;
